module.exports = __webpack_public_path__ + "img/slider_galery_17.87c7a3c4.jpg";